<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import sanitizeClassName from '../../utils/sanitizeClassName';

  let {
    genericLabel,
    headingText = undefined,
    headingTextTemplate = undefined,
    headingLevel = 'h2',
    seePricingText,
    displayInline = false,
    drugs,
    className = $bindable(''),
    headingClasses = 'leading-tight font-medium text-blue-dark-navy text-lg mt-2 mb-6 md:mt-0 md:mb-8 lg:mt-4 lg:mb-16 mx-auto md:text-xl lg:text-2xl max-w-136 lg:max-w-162 sm:text-center',
    fullWidth = displayInline,
    bgBlueParent = false,
    dataTestId = 'lowest-pricing-list',
  } = $props();

  className = sanitizeClassName(className);
</script>

{#if drugs && drugs.length}
  <div class={className} data-testid={dataTestId}>
    {#if headingText || headingTextTemplate}
      <BaseHeading {headingLevel} className={headingClasses}>
        {#if headingText}
          {headingText}
        {:else if headingTextTemplate}
          {headingTextTemplate}
        {/if}
      </BaseHeading>
    {/if}
    <div
      class="grid gap-2"
      class:md:gap-4={fullWidth}
      class:sm:grid-cols-2={fullWidth}
      class:lg:grid-cols-3={fullWidth}
      class:mb-4={fullWidth}
    >
      {#each drugs as { link, name, price, isBrand, form, strength, quantity }, index}
        {#if link}
          <BaseLink
            {...link}
            url={link.url}
            className="flex flex-col justify-between bg-white rounded-lg group relative active:shadow-active shadow-y-sm pseudo-shadow-hover border
            border-gray-light-silver"
            dataTestId="{dataTestId}-pricing-tile"
          >
            <div class="p-3 flex justify-between items-start">
              <div class="flex flex-col mr-4">
                <span class="text-base font-medium tracking-wide">{name}</span>
                {#if form && strength && quantity}
                  <div class="text-sm text-gray-charcoal" data-testid="{dataTestId}-pricing-tile-supplemental-info">
                    <span>{form},</span>
                    <span>{strength},</span>
                    <span>{quantity}</span>
                  </div>
                {/if}
              </div>
              <span class="shrink-0 text-right text-base font-medium text-blue-cerulean">
                {#if price && !isNaN(price.replace(',', ''))}
                  <sup class="text-2xs -top-2">$</sup>
                  {price}
                {:else}
                  {seePricingText}
                {/if}
              </span>
            </div>
            {#if !isBrand}
              <div
                class="py-1 text-center uppercase rounded-b-lg"
                class:bg-blue-very-light={!bgBlueParent}
                class:bg-gray-pale={bgBlueParent}
                data-testid="{dataTestId}-generic-label-{index}"
              >
                <p class="text-blue-navy text-xs font-medium">{genericLabel}</p>
              </div>
            {/if}
          </BaseLink>
        {/if}
      {/each}
    </div>
  </div>
{/if}
